import React from 'react';
import classNames from 'classnames';
import styles from './progress-bar.css';


class ProgressBar extends React.Component {
    constructor() {
        super()
        this.state = {
            score: 0,
        }
        this.handlesize = this.handlesize.bind(this)
    }
    componentDidMount() {
        this.setState({
            score: 0
        })
    }
    handlesize() {
        var dom = document.getElementsByTagName('input')[0]
        var num = Number(dom.value)
        this.setState({
            score: num
        })
    }
    render() {
        const {
            score
        } = this.props
        let scoreProgress_right = null;
        let scoreProgress_left = null;
        if (score >= 0 && score <= 50) {
            const rotate = 45 + 18 / 5 * score
            scoreProgress_right = {
                transform: `rotate(${rotate}deg)`
            }
            scoreProgress_left = {
                transform: `rotate(45deg)`
            }
        } else {
            const rotate = 45 + 18 / 5 * (score - 50)
            scoreProgress_right = {
                transform: `rotate(225deg)`
            }
            scoreProgress_left = {
                transform: `rotate(${rotate}deg)`
            }
        }
        return (
            <div className={classNames(styles.progress)}>
                <div className={classNames(styles.progressRight)}>
                    <div className={classNames(styles.progressBar, styles.progressBarRight)} style={scoreProgress_right}>

                    </div>
                </div>
                <div className={classNames(styles.progressLeft)}>
                    <div className={classNames(styles.progressBar, styles.progressBarLeft)} style={scoreProgress_left}>

                    </div>
                </div>
                <div className={styles.progressNum}>
                    {score}%
                </div>
            </div>

        )
    }
}

export default ProgressBar